// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container_2iskT","spinAround":"HomePage_spinAround_3beKy"};